export default __webpack_public_path__ + "static/media/sticker-ed.d0ba9274.png";